import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import MarkdownContent from '../../../../../../components/MarkdownContent';
import { DynamicFormContext } from '../../context/DynamicFormContext';
import './DynamicFormHeader.less';
function DynamicFormHeader() {
  var _useContext = useContext(DynamicFormContext),
    header = _useContext.header;
  if (_isEmpty(header)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-form-header-container"
  }, header && (_isString(header) ? /*#__PURE__*/React.createElement(MarkdownContent, {
    content: header
  }) : header));
}
export default DynamicFormHeader;